// Module
var code = `<!-- §5 THE APPLICATION SHELL — DRAFT (unratified rough-in; copy of record 2026-08-13).
     Frank's ratification pass may change tiles and close. No eyebrow by ruling. -->
<section class="shell-section" aria-labelledby="shell-headline">

    <div class="shell-section__inner">

        <header class="shell-section__header">
            <h2 id="shell-headline" class="shell-section__headline landing-headline"><span class="landing-eyebrow">GET STARTED</span>
                Start with a complete application.
            </h2>
            <p class="shell-section__lead">
                The Application Shell is a running SpyneJS application, pre-wired: an app model, full
                configuration, and the standard plugins installed.
            </p>
        </header>

        <ul class="shell-section__grid landing-tile-grid landing-tile-grid--3" aria-label="Application Shell plugins">
            <li class="shell-section__tile landing-tile">
                <h3 class="shell-section__tile-name landing-tile__name">CMS</h3>
                <p class="shell-section__tile-body landing-tile__body">
                    Author content — and exchange data with AI — where the application runs. Local JSON files are the database:
                    versionable with the repo, no external service.
                </p>
            </li>
            <li class="shell-section__tile landing-tile">
                <h3 class="shell-section__tile-name landing-tile__name">Behavior Console</h3>
                <p class="shell-section__tile-body landing-tile__body">
                    Every channel, every event, every payload — streaming live as the application runs. The structure describes itself in real time.
                </p>
            </li>
            <li class="shell-section__tile landing-tile">
                <h3 class="shell-section__tile-name landing-tile__name">Spyne-CLI</h3>
                <p class="shell-section__tile-body landing-tile__body">
                    Scaffold, serve, and build from the command line. <code>create-app</code> builds the initial app from your prompt, and can generate VBL code as your app evolves.
                </p>
            </li>
        </ul>

        <p class="shell-section__body">
            Every setting you choose is captured as structured data &mdash; routes, window behavior,
            runtime flags &mdash; declared and embedded in what you download. The <strong>KB Kit</strong> is already
            inside: your AI tools read the current Knowledge Base from the first prompt.
        </p>

        <p class="shell-section__close">
            Keep the editor, the agents, and the workflow you have. The Shell adds the application.
        </p>

        <a data-channel="ROUTE"
           data-event-prevent-default="true"
           data-page-id="configure"
           href="/configure"
           class="shell-section__cta">Start with an Application Shell →</a>

    </div>

</section>
`;
// Exports
module.exports = code;